import { useEffect, useLayoutEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

/**
 * A component to overcome a known limitation of react router where navigating through the pages doesn't scroll to the top, but remains at where it was.
 *
 * @returns {JSX.Element}
 */

function ScrollToAnchor() {
  const location = useLocation();
  const lastHash = useRef("");
  const navbarHeight = 80;
  useEffect(() => {
    if (location.hash.length > 0) {
      lastHash.current = location.hash.slice(1);
    } else {
      lastHash.current = "";
      return;
    }
    if (
      lastHash.current.length > 0 &&
      document.getElementById(lastHash.current) != null
    ) {
      setTimeout(() => {
        const element = document.getElementById(lastHash.current);
        if (element) {
          const elementPosition =
            element.getBoundingClientRect().top + window.scrollY;
          window.scrollTo({
            top: elementPosition - navbarHeight,
            behavior: "smooth",
          });
        }
      }, 100);
    }
  }, [location]);
  useLayoutEffect(() => {
    if (!location.hash) {
      document.documentElement.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    }
  }, [location]);
  return null;
}

export default ScrollToAnchor;
